import { createContainer, createHook, createStore } from 'react-sweet-state';
import { ActionSubject } from '@atlassian/proforma-utils/analytics';
const STORAGE_KEY = 'LastSelectedFormDetails';
const actions = {
  set: formDetails => ({
    setState
  }, {
    errorUtils
  }) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(formDetails));
      setState({
        data: formDetails
      });
    } catch (error) {
      errorUtils.reportError(error, {
        actionSubject: ActionSubject.PROFORMA_UI,
        id: 'LastSelectedFormService'
      });
    }
  }
};
const Store = createStore({
  initialState: {
    data: undefined,
    error: undefined,
    loading: true
  },
  actions,
  name: 'LastSelectedFormService'
});
export const LastSelectedFormServiceContainer = createContainer(Store, {
  onInit: () => ({
    setState
  }, {
    errorUtils
  }) => {
    try {
      const formDetailsString = window.localStorage.getItem(STORAGE_KEY);
      if (formDetailsString) {
        setState({
          data: JSON.parse(formDetailsString)
        });
      }
    } catch (error) {
      // @ts-expect-error error is `unknown`
      setState({
        error
      });
      // @ts-expect-error error is `unknown`
      errorUtils.reportError(error, {
        actionSubject: ActionSubject.PROFORMA_UI,
        id: 'LastSelectedFormService'
      });
    }
    setState({
      loading: false
    });
  }
});
export const useLastSelectedFormService = createHook(Store);